import React from "react";
import { styled } from "baseui";
import { Block } from "baseui/block";
import * as AppConstants from "../../constants/AppConstants";

const HeaderContainer = styled(Block, ({ $theme }) => ({
  backgroundColor: $theme.colors.backgroundAlwaysDark,
  padding: "5px 100px",
  height: AppConstants.APP_SUBHEADER_HEIGHT,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between", // This will space out the child components
  margin: "0px 0px 30px 0px",
}));

// Define a flex container for the children
const HeaderItem = styled(Block, ({ $theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center", // Center the content by default
  flexGrow: 1, // Allow the item to grow
}));

export default function SubHeader({ leftChildren, centerChildren, rightChildren }) {
  return (
    <HeaderContainer>
      <HeaderItem style={{ justifyContent: "flex-start" }}>{leftChildren}</HeaderItem>
      <HeaderItem>{centerChildren}</HeaderItem>
      <HeaderItem style={{ justifyContent: "flex-end" }}>{rightChildren}</HeaderItem>
    </HeaderContainer>
  );
}